import React from 'react';
import PropTypes from 'prop-types';
import { ACCOUNTS, SUPER_ADMIN } from '../../../../../../utils/departments/helpers';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import AccountsNavBar from '../../../../../layouts/accounts/AccountsNavBar';
import ReleaseReportBody from '../../../../shared/release-report/ReleaseReportBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';

const CFOReleaseReport = ({ history }) => {
  useCheckTwoDepartments(`${ACCOUNTS}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AccountsNavBar currentPage="Release Report" position={firstName} />
        {Number(sessionStorage.getItem('roleId')) === 9 ? <ReleaseReportBody /> : null}
      </main>
    </div>
  );
};

CFOReleaseReport.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default CFOReleaseReport;
